module.exports = "https://coursera_assets.s3.amazonaws.com/images/7cb77ce8ffbacf2efc8d43257dc41e8e.svg";